module.exports = function () {
    /**
     * Generates the modal window on the first call.
     *
     */
    const $body = $("body");
    const $html = $("html");
    const $header = $(".page-header");
    const $countrySelectorPopover = $header.find(".country-selector-popover");

    let triggerElement; // Variable to store the element that opened the modal

    const initZoomFocusTrap = () => {
        const focusableElements = "a[href]:visible, button:visible, [tabindex='0']:visible";
        const focusableItems = $countrySelectorPopover.find(focusableElements);
        const firstFocusableElement = focusableItems.first();
        const lastFocusableElement = focusableItems.last();

        $countrySelectorPopover.on("keydown", function (e) {
            const isTabPressed = (e.key === "Tab" || e.keyCode === 9);

            if (!isTabPressed) {
                return;
            }

            if (focusableItems.length === 0) {
                e.preventDefault();
                $countrySelectorPopover.find("[data-dismiss='modal']").focus();
                return;
            }

            if (e.shiftKey) { // If Shift + Tab
                if ($(document.activeElement).is(firstFocusableElement)) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else { // If Tab
                if ($(document.activeElement).is(lastFocusableElement)) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        });

        // Event listener for opening the modal
        $body.on("click keydown", ".country-selector-link", function (e) {
            if (e.type === "click" || (e.type === "keydown" && (e.key === "Enter" || e.key === " "))) {
                e.stopPropagation();
                e.preventDefault();
                triggerElement = this; // Store the element that triggered the modal
                $html.addClass("js-no-scroll");
                $countrySelectorPopover.addClass("show");

                // Move focus to the first focusable element inside the modal
                if (firstFocusableElement.length) {
                    firstFocusableElement.focus();
                }
            }
        });
    };

    // Initialize the focus trap
    initZoomFocusTrap();

    $body.on("click", ".country-selector-close-button", () => {
        $header.find(".popover").removeClass("show");
        $html.removeClass("js-no-scroll");
        if (triggerElement) {
            triggerElement.focus(); // Return focus to the triggering element
        }
    });

    $body.on("click", function (e) {
        if ($countrySelectorPopover.hasClass("show")&&
            $countrySelectorPopover.has(e.target).length <= 0 && $countrySelectorPopover.has(e.target).length <= 0 && !$(e.target).closest("#removeProductModal").length) {
            $countrySelectorPopover.removeClass("show");
            $html.removeClass("js-no-scroll");
        }
    });

    $(document).on("change", ".country-selector-modal.show .js-country-change", function () {

        //make call en Ajax to update language
        $.ajax({
            url: $(this).find(":selected").data("url"),
            success: function (response) {
                $(".js-update-language").empty().html(response);
            },
            error: function () {

            }

        });
    });

    $(document).on("submit", "#submit-country", function (e) {
        e.preventDefault();
        var $form = $(this);
        var action = $(".page").data("action");
        var queryString = $(".page").data("querystring");
        $.ajax({
            url: $form.attr("action"),
            data: {
                action: action,
                queryString: queryString,
                isoCountryCode: $form.find("select[id='countrySelectorCountry']").val(),
                language: $form.find("select[id='countrySelectorLanguage']").val()
            },
            success: function (response) {
                if (response && response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                }
            }
        });
    });
};
